import { render } from "./MemberRegister.vue?vue&type=template&id=be42cb36&scoped=true"
import script from "./MemberRegister.vue?vue&type=script&lang=js"
export * from "./MemberRegister.vue?vue&type=script&lang=js"

import "./MemberRegister.vue?vue&type=style&index=0&id=be42cb36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be42cb36"

export default script